import React, { useEffect, useState } from 'react';

import './Agentes.css';

import { Button, Box, IconButton, FormControl, InputLabel, Paper, Select, MenuItem, Typography, Divider } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import Loading from '../../components/loading/Loading';
import { UserInfo } from '../../dto/UserInfo';
import CustomTableSelectAgentes from '../../components/CustomTableSelectAgentes/CustomTableSelectAgentes';
import { AgentesService } from '../../services/AgentesService';
import { Agente } from '../../dto/Agentes';
import { mostraMensagemErro } from '../../helpers/Notificacoes';
import GroupIcon from '@mui/icons-material/Group';
import SearchIcon from '@mui/icons-material/Search';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import Paginacao from '../../components/paginacao/paginacao';
import { formataFiltrosBusca } from '../../helpers/ValidaAgente';
import MyTextField, { MaskType } from '../../components/inputs/inputBusca';

function AgenteModule() {
    const navigate = useNavigate();
    const userInfo: UserInfo = JSON.parse(localStorage.getItem('udbs')!);

    const [agentes, setAgentes] = useState([]);
    const [buscouAgentes, setBuscouAgentes] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [pageSize] = useState(15);
    const [totalRegistros, setTotalRegistros] = useState(0);
    const arrayColunas: string[] = ['codAgente', 'nome', 'cnpjCpf', 'logradouro', 'bairro', 'fone'];
    const [colunaFilter, setColunaFilter] = useState<string | null>(null);
    const [colunas, setColunas] = useState<string[]>(arrayColunas);
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredAgentes, setFilteredAgentes] = useState([]);
    const [erro, setErro] = useState('');

    const agenteService = new AgentesService(() => {
        navigate('/mvp', {
            state: {
                propsPage: 'login'
            }
        });
    });

    useEffect(() => {
        if (erro !== "") {
            mostraMensagemErro(erro);
        }
    }, [erro]);

    useEffect(() => {
        if (searchTerm.trim() === '' && !buscouAgentes) {
            buscaAgentes();
        }
    }, [searchTerm]);


    useEffect(() => {
        if (searchTerm.trim() === '') {
            setFilteredAgentes(agentes);
            setTotalRegistros(agentes.length)
        }
    }, [searchTerm, agentes]);


    async function buscaAgentes() {
        setIsLoading(true);

        const response = await agenteService.get(`/v1/agente?idEmpresa=${userInfo.idEmpresa}&&agenteRepresentante=${userInfo.idAgente}`);
        if (response.codigo !== 200) {
            if (response.mensagem.includes("Failed to fetch")) {
                setErro("Não foi possível conectar ao servidor. Verifique sua conexão.");
            } else {
                setErro(response.mensagem);
                setAgentes([]);
                setFilteredAgentes([]);
                setTotalRegistros(0);
            }

        } else if (response.status.total === 0 || response.status.agentes === null) {
            setAgentes([]);
            setFilteredAgentes([]);
            setTotalRegistros(0);
            setErro('Não há registros');
            setBuscouAgentes(true);
        } else {
            setErro('');
            setAgentes(response.status.agentes ?? []);
            setFilteredAgentes(response.status.agentes ?? []);
            setTotalRegistros(response.status.total);
            setIsLoading(false);
            setBuscouAgentes(true);
        }
        setIsLoading(false);
    }

    const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
        setPage(value);
    };

    const handleBuscarComFiltro = async () => {
        await buscaAgentesFiltro();
        setPage(1);
    };

    const buscaAgentesFiltro = async () => {
        setIsLoading(true);

        if (searchTerm.trim() === '') {
            setFilteredAgentes(agentes);
        }

        const pFiltro = formataFiltrosBusca(colunaFilter!, searchTerm);
        const response = await agenteService.get(`/v1/agente?idEmpresa=${userInfo.idEmpresa}&&agenteRepresentante=${userInfo.idAgente}&${colunaFilter}=${pFiltro}`);
        if (response.codigo !== 200) {
            if (response.mensagem.includes("Failed to fetch")) {
                return mostraMensagemErro("Não foi possível conectar ao servidor. Verifique sua conexão.");
            }
            mostraMensagemErro(response.mensagem);
            setFilteredAgentes([]);
            setTotalRegistros(0);
            setIsLoading(false);
            return;
        }

        if (response.status.total === 0 || !response.status.agentes) {
            mostraMensagemErro("Nenhum agente encontrado.");
            setFilteredAgentes([]);
            setTotalRegistros(0);
            setIsLoading(false);
            return
        }

        setFilteredAgentes(response.status.agentes);
        setTotalRegistros(response.status.total);
        setIsLoading(false);
    };

    const dadosPaginados = filteredAgentes.slice(
        (page - 1) * pageSize,
        page * pageSize
    );

    const novoAgente = () => {
        navigate("/mvp", {
            state: {
                propsPage: "cadAgente"
            }
        })
    }

    async function editarAgente(agente: Agente) {
        navigate("/mvp", {
            state: {
                agente,
                propsPage: "editarAgente"
            }
        })
    }

    async function handleEditarAgente(agente: Agente) {
        await editarAgente(agente);
    }

    async function handleVisualizarAgente(agente: Agente) {
        await navigate("/mvp", {
            state: {
                agente,
                propsPage: "visualizarAgente"
            }
        })
    }

    return (
        <div className="Home">
            {isLoading && <Loading />}
            <Paper elevation={0} className='agentes-paper-header'>
                <Box className='agentes-header-top'>
                    <Box className='agentes-title-wrap'>
                        <Box className='agentes-title-icon'>
                            <GroupIcon />
                        </Box>
                        <Box>
                            <Box className='agentes-title-line'>
                                <Typography variant='h6' className='agentes-title'>
                                    Agentes Cadastrados
                                </Typography>
                            </Box>
                            <Typography className='agentes-subtitle'>
                                Acompanhe os agentes cadastrados e suas informações detalhadas.
                            </Typography>
                        </Box>
                    </Box>
                    <Divider className='agentes-divider' />
                </Box>
                <Button
                    className='agentes-btn-novo'
                    variant='contained'
                    onClick={novoAgente}
                >
                    Novo agente
                </Button>
                <Box className='agentes-filtros-row'>
                    <FormControl size='small' className='agentes-form-control'>
                        <InputLabel shrink>Filtrar por</InputLabel>
                        <Select
                            value={colunaFilter}
                            onChange={(e: any) => {
                                setColunaFilter(e.target.value);
                                setSearchTerm("");
                            }}
                            label='Filtrar por'
                            displayEmpty
                        >
                            {colunas.map((item) => (
                                <MenuItem key={item} value={item} className='agentes-menu-item'>
                                    {item === 'codAgente' ? 'Código Agente' :
                                        item === 'cnpjCpf' ? 'CNPJ/CPF' :
                                            item === 'nome' ? 'Nome' :
                                                item === 'logradouro' ? 'Logradouro' :
                                                    item === 'bairro' ? 'Bairro' :
                                                        item.charAt(0).toUpperCase() + item.slice(1)}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <Box className='agentes-search-box'>
                        <MyTextField
                            tipo={colunaFilter as MaskType}
                            value={searchTerm}
                            onValueChange={setSearchTerm}
                            onClear={() => {
                                setSearchTerm("");
                                setFilteredAgentes(agentes);
                            }}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") handleBuscarComFiltro();
                            }}
                        />
                    </Box>

                    <IconButton
                        aria-label="Pesquisar"
                        className='agentes-btn-buscar'
                        onClick={handleBuscarComFiltro}
                        disabled={searchTerm === "" && colunaFilter !== "dataLancamento"}
                    >
                        {searchTerm !== "" || colunaFilter === "dataLancamento" ? <SearchIcon /> : <SearchOffIcon />}
                    </IconButton>

                    <button
                        className='agentes-limpar'
                        onClick={() => { setSearchTerm(""); setColunaFilter(null); setFilteredAgentes(agentes); }}
                    >
                        Limpar filtros
                    </button>
                </Box>
            </Paper>

            <div className='ContainerListaAgentes'>
                <CustomTableSelectAgentes
                    data={dadosPaginados}
                    buscouAgentes={buscouAgentes}
                    handleSetAgente={() => { }}
                    isAgente={true}
                    handleEditarAgente={handleEditarAgente}
                    handleVisualizarAgente={handleVisualizarAgente} />

                <div className="PaginationContainer">
                    <Paginacao
                        totalRegistros={totalRegistros}
                        paginaAtual={page}
                        porPagina={pageSize}
                        aoMudarPagina={handlePageChange}
                    />
                </div>
            </div>
            <ToastContainer />
        </div>
    );
}

export default AgenteModule;
